import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-dialog-simple-confirmation',
  templateUrl: './dialog-simple-confirmation.component.html',
  styleUrls: ['./dialog-simple-confirmation.component.scss'],
  standalone: false
})
export class DialogSimpleConfirmationComponent {
  @Input()
  title: string;

  @Input()
  paragraph: string;

  @Input()
  buttonLabel: string;

  @Input()
  set isVisible(isVisible: boolean) {
    this._isVisible = isVisible;
    if (this._isVisible) {
      this.actionButton.focus();
    }
  }

  @Output()
  close: EventEmitter<void> = new EventEmitter();

  @ViewChild('actionButton')
  actionButton: MatButton;

  _isVisible = true;
}
